import React from 'react';
import FormImporter from '../../components/FormImporter';

export default function ImportTally() {
  return (
    <FormImporter
      platform="tally"
      slug="import-from-tally"
      platformName="Tally"
      metaTitle="Tally Form Importer: Free Migration Tool | Fantastic Forms"
      tagline="Migrate from Tally with one paste. We read the public Tally form URL and extract every field (labels, types, options, required flags) into a clean JSON you can recreate inside Fantastic Forms."
      urlExample="https://tally.so/r/xyzABC"
      helpText="Use the publicly-shared Tally URL (the one starting with tally.so/r/). Password-protected and private Tally forms can't be imported."
    />
  );
}
